// src/components/AdminPortal/UserManagement/SuperAdminUsers.js
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "../../User.css";
import "../UserManagement.css";
import Axios from "../../../utils/axios";

const SuperAdminUsers = () => {
  const [superAdmins, setSuperAdmins] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchSuperAdmins = async () => {
    try {
      setLoading(true);

      const response = await Axios.get(`/api/user/getSuperAdmin`);
      const apiData = response?.data || [];

      if (apiData.success && apiData.data) {
        setSuperAdmins([apiData.data]);
      } else {
        setSuperAdmins([]);
      }
    } catch (error) {
      toast.error("Failed to load Super Admin Users");
      setSuperAdmins([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuperAdmins();
  }, []);

  // ✅ Filtered search
  const filteredSuperAdmins = superAdmins.filter(
    (admin) =>
      admin.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      admin.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      admin.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      admin.phone_number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      admin.address?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="table-container">
      <h2>Super Admin Users</h2>
      <div
        className="search-and-new"
        style={{ display: "flex", marginBottom: "15px" }}
      >
        <input
          type="text"
          placeholder="Search by Username, Full Name, Email, Phone, or Address..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
          style={{ flexGrow: 1, marginRight: "10px" }}
        />
        <button onClick={() => setSearchTerm("")} className="clear-button">
          Clear
        </button>
      </div>

      {/* 📊 Data Table */}
      {loading ? (
        <p>Loading super admin users...</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Full Name</th>
              <th>Phone Number</th>
              <th>Email</th>
              <th>Address</th>
              <th>Roles</th>
            </tr>
          </thead>
          <tbody>
            {filteredSuperAdmins.length > 0 ? (
              filteredSuperAdmins.map((admin, index) => (
                <tr key={index}>
                  <td>{admin.username}</td>
                  <td>{admin.full_name}</td>
                  <td>{admin.phone_number}</td>
                  <td>{admin.email}</td>
                  <td>{admin.address}</td>
                  <td>
                    {Array.isArray(admin.roles) ? admin.roles.join(", ") : ""}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No super admin users found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SuperAdminUsers;
